import { Autocomplete } from "../../components/Autocomplete";
import { useMemo } from "react";
import { Dialog } from "../../components/Dialog";
import Stack from "@mui/material/Stack";
import { ButtonProps } from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { DAYS, FREQUENCY, MONTH_DAYS } from "../../utils/constants";

type DialogReprocessInsightProps = {
  value: any;
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onChange: (data: any) => void;
  onSave: () => void;
};

export const DialogReprocessInsight = ({
  value,
  open,
  loading,
  onClose,
  onChange,
  onSave,
}: DialogReprocessInsightProps) => {
  const whenSendOptions = useMemo(() => {
    return value.unitTimeAutomacao?.value !== "months" ? DAYS : MONTH_DAYS;
  }, [value.unitTimeAutomacao]);

  const showWhenSendOptions = useMemo(() => {
    return value.unitTimeAutomacao && value.unitTimeAutomacao?.value !== "days";
  }, [value.unitTimeAutomacao]);

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        disabled: loading,
        children: "Fechar",
        onClick: onClose,
      },
      {
        disabled: loading,
        variant: "contained",
        children: loading ? "Enviando solicitação" : "Automatizar",
        onClick: onSave,
      },
    ];
  }, [loading, onClose, onSave]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      title="Informações da automação"
      open={open}
      actions={actions}
      onClose={onClose}
    >
      <Stack my={2} spacing={4}>
        <TextField
          type="number"
          label="Intervalo"
          autoFocus
          onChange={({ target }) => onChange({ unitAutomacao: target.value })}
          fullWidth
          size="small"
          value={value.unitAutomacao}
          InputProps={{
            inputProps: {
              min: 0,
            },
          }}
        />
        <Autocomplete
          size="small"
          label="Frequência"
          options={FREQUENCY}
          getOptionLabel={(option) => option.label}
          onChange={(_, value) => onChange({ unitTimeAutomacao: value })}
          value={value.unitTimeAutomacao}
        />
        {showWhenSendOptions && (
          <Autocomplete
            size="small"
            label="Quando enviar"
            options={whenSendOptions}
            getOptionLabel={(option) => option.label}
            onChange={(_, value) => onChange({ diaDisparoAutomacao: value })}
            value={value.diaDisparoAutomacao}
          />
        )}
      </Stack>
    </Dialog>
  );
};
